"use client";

import { c as _c } from "react/compiler-runtime";
import { trackEmailComposerAction } from "../../analytics";
import { useEmailComposer } from "../../context";
import { useCallback, useEffect, useRef, useState } from "react";
import { LuPaintbrush } from "react-icons/lu";
import { Button } from "@/components/ui";
interface StoredFormat {
  marks: readonly import("@tiptap/pm/model").Mark[];
  textAlign: string | null;
}
export function PaintFormatButton() {
  const $ = _c(13);
  const {
    editor
  } = useEmailComposer();
  const [active, setActive] = useState(false);
  const storedFormatRef = useRef(null);
  let t0;
  if ($[0] !== editor) {
    t0 = () => {
      if (!editor) {
        return;
      }
      const {
        from,
        to,
        empty
      } = editor.state.selection;
      let marks;
      if (empty) {
        marks = editor.state.storedMarks ?? editor.state.selection.$from.marks();
      } else {
        let found = [];
        editor.state.doc.nodesBetween(from, to, n => {
          if (n.isText && found.length === 0) {
            found = n.marks;
            return false;
          }
        });
        marks = found;
      }
      const {
        $from
      } = editor.state.selection;
      let textAlign = null;
      for (let d = $from.depth; d >= 0; d--) {
        const node = $from.node(d);
        if (node.attrs.textAlign) {
          textAlign = node.attrs.textAlign as string;
          break;
        }
      }
      storedFormatRef.current = {
        marks,
        textAlign
      };
      setActive(true);
      trackEmailComposerAction("paint_format_activated", "toolbar");
    };
    $[0] = editor;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const captureMarks = t0;
  let t1;
  let t2;
  if ($[2] !== active || $[3] !== editor) {
    t1 = () => {
      if (!editor || !active) {
        return;
      }
      const editorDom = editor.view.dom;
      const applyFormat = () => {
        queueMicrotask(() => {
          if (!storedFormatRef.current) {
            return;
          }
          const {
            from: from_0,
            to: to_0,
            empty: empty_0
          } = editor.state.selection;
          if (empty_0) {
            return;
          }
          const {
            marks: marks_0,
            textAlign: textAlign_0
          } = storedFormatRef.current;
          const {
            tr
          } = editor.state;
          Object.values(editor.schema.marks).forEach(markType => {
            tr.removeMark(from_0, to_0, markType);
          });
          for (const mark of marks_0) {
            tr.addMark(from_0, to_0, mark);
          }
          if (textAlign_0) {
            const $pos = tr.doc.resolve(from_0);
            for (let d_0 = $pos.depth; d_0 >= 0; d_0--) {
              const node_0 = $pos.node(d_0);
              if ("textAlign" in node_0.attrs) {
                tr.setNodeMarkup($pos.before(d_0), undefined, {
                  ...node_0.attrs,
                  textAlign: textAlign_0
                });
                break;
              }
            }
          }
          editor.view.dispatch(tr);
          storedFormatRef.current = null;
          setActive(false);
          trackEmailComposerAction("paint_format_applied", "toolbar");
        });
      };
      const handleKeyDown = e => {
        if (e.key === "Escape") {
          storedFormatRef.current = null;
          setActive(false);
        }
      };
      editorDom.addEventListener("mouseup", applyFormat);
      document.addEventListener("keydown", handleKeyDown);
      return () => {
        editorDom.removeEventListener("mouseup", applyFormat);
        document.removeEventListener("keydown", handleKeyDown);
      };
    };
    t2 = [editor, active];
    $[2] = active;
    $[3] = editor;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== active || $[7] !== captureMarks) {
    t3 = () => {
      if (active) {
        storedFormatRef.current = null;
        setActive(false);
      } else {
        captureMarks();
      }
    };
    $[6] = active;
    $[7] = captureMarks;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = active ? "bg-primary/20 text-primary" : "";
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <LuPaintbrush size={16} />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4) {
    t6 = <Button type="button" variant="ghost" size="icon-sm" onMouseDown={_temp} onClick={t3} className={t4} tooltip="Paint format">{t5}</Button>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
function _temp(e_0) {
  return e_0.preventDefault();
}